import { Box, CircularProgress, Container } from "@mui/material";
import YantraCards from "./cards";
import ControlBoard from "../controlBoard/controlBoard";
import { useEffect } from "react";
import { YantraExecution, YantraExecutionInfo } from "../../tanstack/queries/player";
import StatusLine from "./StatusLine";
import { listenYantra, stopListenYantra } from "../../utils/socket.ts";
import { setActiveExecution } from "../../stores/statusStore/statusStore";
import { IRequestBody, setLastBet } from "../../stores/cardsStore/CardsStore.ts";

interface ICardsContainerProps {
  execution?: YantraExecution;
  isLoading?: boolean;
}

export default function CardsContainer({ execution, isLoading = false }: ICardsContainerProps) {
  useEffect(() => {
    if (execution) {
      const { yantraId, countryCode, currency } = execution;

      listenYantra(yantraId, `${countryCode}!${currency}`);

      setActiveExecution(execution.id, execution.yantraId);

      return () => {
        stopListenYantra(yantraId, `${countryCode}!${currency}`);
      };
    }
  }, [execution]);

  const yantraInfo = execution as YantraExecutionInfo;

  useEffect(() => {
    if (!execution?.yantraId) return;

    try {
      const raw = localStorage.getItem("last-bets-yantra");
      if (!raw) return;
      const bets: Array<{ yantraID: string; lastBet: IRequestBody }> = JSON.parse(raw);

      const foundBet = bets.find((bet) => bet.yantraID === execution.yantraId);
      if (foundBet) {
        setLastBet(foundBet.lastBet);
      }
    } catch (e) {
      console.error("Failed to parse last bet from storage", e);
    }
  }, [execution?.yantraId]);

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        minHeight: "100vh",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
          alignSelf: "start",
          width: "100%",
          background: "#A2333C",
          borderRadius: { xs: 0, md: 3 },
          px: 2.5,
          pt: 1.25,
          pb: 2,
        }}
      >
        {!isLoading && <StatusLine name={yantraInfo.name} />}
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          p: 1.75,
          overflow: "visible",
        }}
      >
        {/* cards */}

        {isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "35%",
              color: "white",
              minHeight: (theme) => theme.spacing(20),
            }}
          >
            <CircularProgress size="3rem" color="inherit" />
          </Box>
        )}

        {!isLoading && <YantraCards yantras={yantraInfo.yantras} rows={yantraInfo.yantraRows} cols={yantraInfo.yantraCols} />}

        {/* board */}
        <ControlBoard />
      </Box>
    </Container>
  );
}
